import { IOption } from '@shared';
import { createReducer, on } from '@ngrx/store';
import { getActivitiesSuccess } from '../actions';

const initialState: IOption[] = [];

export const activitiesReducer = createReducer(
  initialState,
  on(getActivitiesSuccess, (state, { activities }) => activities),
);
